import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PlainTextNode } from 'src/app/dto';

@Component({
    selector: 'app-plain-text-node',
    templateUrl: './plain-text-node.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlainTextNodeComponent {
    @Input() node: PlainTextNode;
}
